import { FileItem } from '@inno-sdks/files'

import { mimeTypes } from '../constants'

export function isDrawingFile(item: FileItem): boolean {
  return item.metaData.mimeType === mimeTypes.drawing.excalidraw
}
